// import { get } from "sortablejs";
import { ednLang } from './ednLang'

//Mixin de simplification de spécification de messages pour les champs obligatoires.
export const ednRequired = {
  data() {
    return {
      rules: [],
      sRequiredMsg: '',
    }
  },
  mixins: [ednLang],
  computed: {
    /** Permet de récupérer la valeur de required dans le cas où c'est une props ou un attrs, un bool ou un string */
    fldRequiredVal:function(){
      let required = this.required || this.$attrs.required;
      return required || typeof required === 'string' && required == '';
    },
    /**
     * Récupère le message obligatoire par l'intermediaire d'une locale
     */
    requiredMsg: {
      get: function () {
        return typeof this.fldRequiredVal === 'string' && this.fldRequiredVal != ''
          ? this.fldRequiredVal
          : this.sRequiredMsg
      },
      set: function (val) {
        this.sRequiredMsg = val
      },
    },
    /** Est-ce que le cat est multiple ou non */
    isMultiple(){
      return this.multiple || this.$attrs.multiple || (this.$attrs.hasOwnProperty('multiple') && this.$attrs.multiple === "")
    }
  },
  created() {
    // On récupère la res par défaut pour le message obligatoire
    this.sRequiredMsg = this.$vuetify.lang.t('$vuetify.ednRequired');
    this.rules = this.isRequired();
  },
  watch: {
    // Met à jour les règles par rapport au requiered
    'required': function () {
      this.rules = this.isRequired();
    },
    /**
     * Met à jour le message invalide si la langue change
     */
    '$vuetify.lang.current': function () {
      this.sRequiredMsg = this.$vuetify.lang.t('$vuetify.ednRequired')
    },
  },
  methods: {
    /**
     * Renvoie l'attribut required si celui-ci est un caractère et est rempli sinon la valeur
     */
    isRequired() {
      if (this.fldRequiredVal) {
        if (this.isMultiple && this.$options.name == 'edn-cat') {
          return [(value) => (value && !!value.length) || this.requiredMsg]
        } else {
          return [(value) => (value && !!value) || this.requiredMsg]
        }
      }else{
        return []
      }
    },
  },
}
